type BroodRoom = '3r' | '5r' | '6r' | '10r' | '20r';

type Props = {
  broodRoom: BroodRoom | string | null | undefined;
  width?: number;
  className?: string;
  title?: string;
};

function norm(v: string): BroodRoom | null {
  const k = v.trim().toLowerCase();
  if (k === '3r' || k === '5r' || k === '6r' || k === '10r' || k === '20r') return k;
  return null;
}

export function BroodRoomIcon({ broodRoom, width = 24, className, title }: Props) {
  const v = norm(String(broodRoom ?? ''));
  const vbW = 40;
  const vbH = 40;
  const height = Math.round((width / vbW) * vbH);

  const stroke = '#374151';
  const rr = 2;
  const line = 1.4;

  const COLORS = {
    yellow: '#fde047',
    orange: '#fb923c',
  };

  const aria = title ?? `Yngelrum: ${v ?? 'okänt'}`;

  return (
    <svg width={width} height={height} viewBox={`0 0 ${vbW} ${vbH}`} role="img" aria-label={aria} className={className}>
      {v === '20r' && (
        <>
          <rect x="6" y="4" width="28" height="10" rx={rr} fill={COLORS.yellow} stroke={stroke} strokeWidth={line} />
          <rect x="6" y="18" width="28" height="10" rx={rr} fill={COLORS.yellow} stroke={stroke} strokeWidth={line} />
          <line x1="6" y1="16" x2="34" y2="16" stroke={stroke} strokeOpacity="0.25" strokeWidth="1" />
        </>
      )}

      {v === '10r' && <rect x="6" y="9" width="28" height="14" rx={rr} fill={COLORS.orange} stroke={stroke} strokeWidth={line} />}

      {(v === '3r' || v === '5r' || v === '6r') && (
        <>
          <rect x="10" y="6" width="30" height="6" rx={1} fill="#e5e7eb" stroke="#9ca3af" strokeWidth={0.8} />
          <rect x="16" y="12" width="18" height="28" rx={2} fill="#fff" stroke="#9ca3af" strokeWidth={0.8} />
          <circle cx="25" cy="32" r="3" fill="#111827" />
        </>
      )}

      {!v && (
        <>
          <rect x="10" y="6" width="20" height="20" rx={rr} fill="#ffffff" stroke="#9ca3af" strokeWidth={line} />
          <circle cx="14" cy="22" r="2" fill="#111827" />
        </>
      )}
    </svg>
  );
}
